import { CSSObject } from '@mui/material/styles';
import { Drawer } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

// const drawerWidth = 300;

interface StyledDrawerProps {
  open: boolean;
  drawerWidth: number;
}

const openedMixin = (theme: Theme, drawerWidth: number): CSSObject => ({
  width: drawerWidth,
  backgroundColor: '#1A1A2E',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '5rem',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'visible',
  backgroundColor: '#1A1A2E',
  width: `calc(${theme.spacing(10)} + 1px)`,
});

const StyledDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerWidth' })<StyledDrawerProps>(
  ({ theme, open, drawerWidth }) => ({
    width: drawerWidth,
    flexShrink: 0,
    padding: '0 1rem',
    backgroundColor: '#1A1A2E',
    whiteSpace: 'nowrap',
    overflow: 'visible',

    boxSizing: 'border-box',
    // ✅ When open
    ...(open && {
      ...openedMixin(theme, drawerWidth),
      '& .MuiDrawer-paper': {
        ...openedMixin(theme, drawerWidth),
      },
    }),

    // ✅ When closed
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': {
        ...closedMixin(theme),
      },
    }),
    '& .MuiDrawer-paper': {
      backgroundColor: '#1A1A2E',
      zIndex: 1099,
      color: 'white',
      borderRight: 'none',
      overflow: 'visible',
    },
  }),
);

export default StyledDrawer;
